import React from 'react';
import SubIndex from '../sub-index';

const SubLayoutPage = ({ children }) => {
  return <SubIndex>{children}</SubIndex>;
};

export default SubLayoutPage;
